module.exports = __webpack_public_path__ + "img/youssry.9bd11cfa.webp";